var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17806 15.3351C9.2698 15.4683 9.39255 15.5772 9.53575 15.6525C9.67895 15.7278 9.83829 15.7671 10.0001 15.7671C10.1618 15.7671 10.3212 15.7278 10.4644 15.6525C10.6076 15.5772 10.7303 15.4683 10.8221 15.3351L19.8221 2.33505C19.9262 2.18511 19.9873 2.00948 19.9987 1.82726C20.0101 1.64503 19.9713 1.46318 19.8865 1.30145C19.8018 1.13972 19.6744 1.0043 19.5181 0.90991C19.3618 0.81552 19.1826 0.765766 19.0001 0.766053H1.00006C0.817902 0.766806 0.639397 0.8172 0.483739 0.911816C0.328082 1.00643 0.201162 1.14169 0.116628 1.30305C0.0320935 1.4644 -0.0068559 1.64575 0.00396806 1.82758C0.014792 2.00942 0.0749798 2.18487 0.178059 2.33505L9.17806 15.3351Z",
    fill: "#ABABAB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDisabled);
export default __webpack_public_path__ + "static/media/arrowDownDisabled.a9fa703222618307e4109a83910adeb7.svg";
export { ForwardRef as ReactComponent };